const program = require('commander')
const execSync = require('child_process').execSync
const util = require('../lib/util')
const log = require('./log')

program
  .command('push')
  .action(() => {
    log.debug(111)
  })
  .parse(process.argv)


log.debug(program.args)

log.debug(process.argv)
